<template>
  <div class="container tem001">
    <HeadingOne>お申し込み完了</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="3" type="en2"></MainWizard>
    </WizardGroup>

    <StepPage class="-success">
      <StepHeader class="complete">
        <img
          src="@/assets/images/icons/check-ok.svg"
          class="_i-w-sm-37 _i-w-md-74 _mb-sm-15 _mb-md-30"
          alt=""
        />
        <h2 class="heading">
          ご本人さま確認書類のアップロードが完了しました。
        </h2>
        <p class="_mb-0">
          これでお申し込みは完了となります。
          <br />
          このたびはお申し込みいただき誠にありがとうございました。
        </p>
        <small class="complete-note"
          >※ 下記電話番号よりお電話を差し上げることがございます。<br />･ご入力された情報に不備があった場合<br />･当社がお客さまに確認が必要と判断した場合</small
        >
      </StepHeader>
      <TelBox></TelBox>
      <StepBody>
        <StepList type="tem" class="-orange">
          <HeadingIcon class="-bold _mb-30">
            <IconBox src="note" class="-w30 _mr-sm-5 _mr-md-10"></IconBox>
            <h3 class="heading">ご利用までの流れについて</h3>
          </HeadingIcon>
          <StepItem
            number="1"
            title="審査完了をメールでご連絡（最短30分※）"
            src="page/tem001/step1.gif"
            class="-sm"
          >
            <p>
              審査完了次第、ご登録いただいたメールアドレスに「審査完了のお知らせ【au
              PAY スマートローン】」の件名で審査結果をご案内します。
            </p>
            <small
              >※お申し込みの時間帯や審査状況によっては、翌日以降のご連絡となる場合がございます。</small
            >
          </StepItem>
          <StepItem
            number="2"
            title="「確認コード」が記載されたハガキをお送りします"
            src="page/tem001/step2.gif"
            class="-sm"
          >
            <p>
              ご融資可能なお客さまにはご契約に必要な「確認コード」を記載したハガキをご登録住所あてに「転送不要」の簡易書留または、本人限定受取郵便にてお送りさせていただきますので、必ずお受取りください。なお、郵便には保管期限がございますので、ご注意ください。
            </p>
            <small
              >※ご契約までのお手続きに約１週間程度お時間がかかりますので、あらかじめご了承ください。</small
            >
          </StepItem>
          <StepItem
            number="3"
            title="審査結果確認～ご契約手続き"
            src="page/tem001/step3.gif"
            class="-last -sm"
          >
            <p>
              ハガキに記載されている手順に沿って審査結果のご確認ページへアクセスしてください。ステップ２で届いた「確認コード」を入力し、そのままご契約手続きとなります。
            </p>
            <small
              >※本サイトのトップページからも審査結果をご確認いただけます。</small
            >
          </StepItem>
          <StepFooter>
            <template #heading>サービスご利用開始</template>
            <template #text>
              <p class="_mt-15">ご契約締結後、すぐにお借り入れが可能です。</p>
              <p>
                お借り入れ方法について詳しくは<BtnText
                  router-name="sv046"
                  class="-underline"
                  >こちら</BtnText
                >
              </p>
            </template>
          </StepFooter>
        </StepList>
      </StepBody>
    </StepPage>

    <ListGroup class="-note _mt-20">
      <ListItem class="-note"
        >お申し込み内容により、お手続きにお時間がかかる場合や、ご希望に添えない場合がございます。</ListItem
      >
      <ListItem class="-note"
        >お申し込み内容や在職確認等のため、お電話させていただく場合がございます。</ListItem
      >
    </ListGroup>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-normal -md" router-name="sv001">
        au PAY スマートローントップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import StepPage from "@/components/steps/StepPage";
import StepHeader from "@/components/steps/StepHeader";
import StepBody from "@/components/steps/StepBody";
import StepList from "@/components/steps/StepList";
import HeadingIcon from "@/components/heading/HeadingIcon";
import IconBox from "@/components/icons/IconBox";
import StepItem from "@/components/steps/StepItem";
import StepFooter from "@/components/steps/StepFooter";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BtnText from "@/components/button/BtnText";
import TelBox from "@/components/box/TelBox";
export default {
  name: "Tem001",
  components: {
    BtnText,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    StepFooter,
    StepItem,
    IconBox,
    HeadingIcon,
    StepList,
    StepBody,
    StepHeader,
    StepPage,
    MainWizard,
    WizardGroup,
    HeadingOne,
    TelBox,
  },
  setup() {
    setMeta({
      title: "お申し込み完了",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,本人確認書類",
    });
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.steps-box {
  padding: 20px;
  @include mq-down(md) {
    margin-right: -20px;
    margin-left: -20px;
  }
  @include mq-up(md) {
    border-radius: 10px;
  }
  &.-success {
    background-color: $success;
  }
  > .steps-header {
    text-align: center;
    padding: 30px 0px 13px;
    @include mq-up(md) {
      padding: 40px 20px 60px;
    }
    .heading {
      color: $primary;
      font-weight: bold;
      font-size: 20px;
      @include mq-up(md) {
        font-size: 32px;
      }
    }
  }
  > .steps-body {
    background-color: $white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 2px 2px rgba($secondary, 0.6);
    @include mq-up(md) {
      border-radius: 10px;
      padding: 40px;
    }
  }
}

.steps-header.complete {
  padding-bottom: 13px;
}

small.complete-note {
  display: block;
  text-align: left;
  @include mq-down(md) {
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 20px;
  }
  @include mq-up(md) {
    margin-top: 17px;
    margin-bottom: 14px;
    line-height: 24px;
  }
}
</style>
